import React, { ChangeEvent } from "react";

import Setting from "@app/analytics/account/components/Setting";
import SettingContent from "@app/analytics/account/components/SettingContent";
import SettingWithToggle from "@app/analytics/account/components/SettingWithToggle";
import { getSettingDisabledOpts } from "@app/analytics/account/UserPreferences/utils";
import useUserSettings from "@app/analytics/hooks/settings/useUserSettings";
import { useAuthenticated } from "@app/common/auth/useAuth";
import useFeatureAccess from "@app/common/hooks/useFeatureAccess";

const GeneralSettings = () => {
  const { user } = useAuthenticated();
  const { updateUserSettings } = useUserSettings();

  const { canEditAffectiveMetricsEnabled } = useFeatureAccess();

  const handleUpdateAffectiveMetricsSetting = (
    _e: ChangeEvent,
    checked: boolean
  ) => {
    updateUserSettings.mutate({ affectiveMetricsEnabled: checked });
  };

  const disabledProps = getSettingDisabledOpts(canEditAffectiveMetricsEnabled);

  return (
    <Setting title="General">
      <SettingContent>
        <SettingWithToggle
          title="Affective metrics"
          description="Include metrics that calculate engagement, sentiment, charisma, and bias in reports."
          onChange={handleUpdateAffectiveMetricsSetting}
          checked={user.affectiveMetricsEnabled}
          disabled={disabledProps.disabled}
          disabledTooltip={disabledProps.tooltip}
        />
      </SettingContent>
    </Setting>
  );
};

export default GeneralSettings;
